import serviciosExternos from "./serviciosExternos"

export default {
    title: 'Hospital Angeles Servicios Externos de Diagnóstico',
    description: 'Hospital Angeles Servicios Externos de Diagnóstico',
    widgets: (filters: FiltersUI) => {
        //console.log('rendering  servcios externos widgets')
        const newWidgets = serviciosExternos.widgets(filters)
            /*?.map(widget => {
                return {
                    ...widget,
                    config: {
                        ...widget.config,
                        indicators: widget.config?.indicators
                            ?.map((ind: any) => {
                                return {
                                    ...ind,
                                    extras: {
                                        ...ind.extras,
                                        responseValues: { 11954: [1] },
                                        criticalMomentInclude: [12051]
                                    }
                                }
                            })
                    }
                }
            })*/

            //console.log(newWidgets)
            return newWidgets
    },
} as DasboardConfig
